import axios from "axios";
import {
  wd_refreshGlobalAccessToken,
  wd_corporationSignIn,
} from "@/service/apiLogin.js";
import { userKeys } from "@/service/wd_app_config.js";

const axiosInstance = axios.create({
  baseURL: "", // 所有请求的公共地址部分
  withCredentials: true, //是否允许跨域
  timeout: 180000, // 请求超时时间 这里的意思是当请求时间超过5秒还未取得结果时 提示用户请求超时
});

// 请求拦截器 在请求拦截中可以补充请求相关的配置
// interceptors axios的拦截器对象
axiosInstance.interceptors.request.use(
  (config) => {
    // config 请求的所有信息
    let token = window.localStorage.getItem(userKeys.key_globalAccessToken);
    if(token){
      config.headers.Authorization = `Bearer ${token}`
    }
    return config; // 将配置完成的config对象返回出去 如果不返回 请求讲不会进行
  },
  (err) => {
    // 请求发生错误时的相关处理 抛出错误
    Promise.reject(err);
  }
);

// response 拦截器
axiosInstance.interceptors.response.use(
  (res) => {
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    return Promise.resolve(res);
  },
  (err) => {
    // 服务器响应发生错误时的处理
    if (err.response && err.response.status == 401) {
      var res = wd_refreshGlobalAccessToken()
        .then((response) => {
          if (response.data.Code == 0) {
            localStorage.setItem(
              userKeys.key_globalAccessToken,
              response.data.Result.GlobalAccessToken
            );
            localStorage.setItem(
              userKeys.key_globalRefreshToken,
              response.data.Result.GlobalRefreshToken
            );

            // 重新Corporations SignIn
            /* var params = {
              clientInstallationId: localStorage.getItem(
                userKeys.key_clientInstallationId
              ),
            }; */
            return wd_corporationSignIn().then((response) => {
              if (response.data.Code == 0) {
                localStorage.setItem(
                  userKeys.key_corporationAccessToken,
                  response.data.Result.AccessToken
                );
                localStorage.setItem(
                  userKeys.key_corporationObject,
                  JSON.stringify(response.data.Result.Corporation)
                );
                localStorage.setItem(
                  userKeys.key_userObject,
                  JSON.stringify(response.data.Result.User)
                );

                // 重新调用原请求
                if (err.config.method == "post") {
                  return axiosInstance.post(err.config.url, err.config.data, {
                    headers: {
                      AccessToken: response.data.Result.AccessToken,
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  });
                } else if (err.config.method == "get") {
                  return axiosInstance.get(err.config.url, {
                    headers: {
                      AccessToken: response.data.Result.AccessToken,
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  });
                }
              }
            });
          }
        })
        .then((response) => {
          console.log("refresh token, resolve");
          return response;
        });
      return Promise.resolve(res);
    }
    return Promise.reject(err);
  }
);

export { axiosInstance };
